import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-58bda90a")

_pushScopeId("data-v-58bda90a")
const _hoisted_1 = { class: "flex flex-center" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("确定")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_cascader = _resolveComponent("el-cascader")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.currentTags, (tag) => {
      return (_openBlock(), _createBlock(_component_el_tag, {
        key: tag,
        closable: "",
        "disable-transitions": false,
        onClick: ($event: any) => (_ctx.showTagNameEditor(tag)),
        onClose: ($event: any) => (_ctx.handleClose(tag))
      }, {
        default: _withId(() => [
          _createTextVNode(_toDisplayString(tag.name), 1)
        ]),
        _: 2
      }, 1032, ["onClick", "onClose"]))
    }), 128)),
    _createVNode(_component_el_input, {
      class: "input-new-tag",
      modelValue: _ctx.inputValue,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.inputValue = $event)),
      placeholder: "创建新标签",
      ref: "saveTagInput",
      size: "small",
      onKeyup: _withKeys(_ctx.handleInputConfirm, ["enter"]),
      onBlur: _ctx.handleInputConfirm
    }, null, 8, ["modelValue", "onKeyup", "onBlur"]),
    _createVNode(_component_el_dialog, {
      title: "修改标签",
      modelValue: _ctx.editDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.editDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode("div", null, [
          _createVNode(_component_el_input, {
            class: "margin-bottom-10",
            modelValue: _ctx.currentTagName,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTagName = $event))
          }, null, 8, ["modelValue"]),
          _createVNode(_component_el_cascader, {
            modelValue: _ctx.currentTagCategoryIds,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentTagCategoryIds = $event)),
            options: _ctx.tagCategories,
            props: {value: 'id', label: 'name', checkStrictly: true}
          }, null, 8, ["modelValue", "options"]),
          _createVNode("div", _hoisted_1, [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "mini",
              onClick: _ctx.updateTagName
            }, {
              default: _withId(() => [
                _hoisted_2
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})